<template>
	<div>
		<side-bar-component></side-bar-component>

		<toasts></toasts>
		<div class="core" :class="{ external: $route.name === 'list' && module.is_external }">
			<router-view></router-view>
		</div>

		<switch-account-menu></switch-account-menu>
		<modal-definitions></modal-definitions>
	</div>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import SideBarComponent from './nav/SideBarComponent';
import SwitchAccountMenu from './SwitchAccountMenu';
import ModalDefinitions from './modals/ModalDefinitions';

export default {

	data() {
		return {
			form: {
				theme: 1,
			},
		};
	},

	computed: {

		...mapGetters([ 'hasToasts', 'module' ]),

		...mapState({
			theme: state => state.layout.theme,
			menuOpen: state => state.layout.menuOpen,
		}),

	},

	mounted() {
		this.$set(this.form, 'theme', this.theme === 'dark' ? 1 : 0);
	},

	methods: {

		openMenu() {
			this.$store.dispatch('openMenu');
		},

		closeMenu() {
			this.$store.dispatch('closeMenu');
		},

		closeAccountMenu() {
			this.$store.dispatch('closeAccountMenu');
		},

	},

	watch: {
		'$route': function() {
			this.$store.dispatch('closeMenu');
			this.$store.dispatch('closeAccountMenu');
		},
		'form.theme': function(newValue) {
			const theme = newValue ? 'dark' : 'light';
			this.$api.post('/user', { theme });
			this.$store.dispatch('updateTheme', { theme, store: true });
		},
		theme(newValue) {
			this.$set(this.form, 'theme', newValue === 'dark' ? 1 : 0);
		},
	},

	components: {
		SideBarComponent,
		SwitchAccountMenu,
		ModalDefinitions,
	}
};
</script>
